export enum LocationTypeEnum {
  Country = 0,
  Region = 1,
  FederationUnit = 2,
  City = 3,
  Neighborhood = 4,
  District = 6,
  Pma = 102
}
